/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useEffect } from 'react';
import { uiSchemaProperties } from '../../../shared/enums/uiSchemaProperties';
import { searchFieldById } from '../../../shared/utils/objectUtils';

/* Autocomplete trigger hook */
export function useAutocompleteTrigger(id, uiSchema, formContext, callback) {
  const triggerField = uiSchema[uiSchemaProperties.UI_AUTOCOMPLETE_TRIGGER] ?? [];
  // widget root id
  const rootId = id?.replace(triggerField?.base, '');
  // target field value for listening object
  const targetFieldVal = searchFieldById(formContext, `${rootId}${triggerField.target}`);
  // current value that provide by validate service
  const textWidgetVal = searchFieldById(formContext, id);

  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    targetFieldVal && callback && callback(textWidgetVal);
  }, [targetFieldVal]);
}